<template>
	<v-sheet class="customer" style="height: calc(100vh - 88px)">
		<template v-if="contentLoaded">
			<v-layout class="align-center light-blue-bg px-4 py-2">
				<v-flex md12>
					<div class="d-flex">
						<p class="my-auto font-level-3-bold">
							<v-chip color="cyan" class="ml-2 mr-2" label text-color="white">{{
								location.barcode
							}}</v-chip>
						</p>
						<v-spacer></v-spacer>

						<v-btn
							v-if="getPermission('property:update')"
							v-on:click="doAction('edit')"
							color="blue darken-4 text-white"
							class="ml-2"
							depressed
							tile
							><v-icon small left>mdi-pencil</v-icon>Edit</v-btn
						>
						<template v-if="getPermission('property:delete')">
							<v-btn
								v-if="!location.is_owner"
								v-on:click="doAction('delete')"
								color="blue darken-4 text-white"
								class="ml-2"
								depressed
								tile
								><v-icon small left>mdi-delete</v-icon>Delete</v-btn
							>
						</template>
						<template v-if="!location.is_owner">
							<template v-if="getPermission('property:update')">
								<v-btn
									v-if="location.activated"
									v-on:click="doAction('deactivate')"
									color="blue darken-4 text-white"
									class="ml-2"
									depressed
									tile
									><v-icon small left>mdi-cancel</v-icon>De-activate</v-btn
								>
								<v-btn
									v-else
									v-on:click="doAction('activate')"
									color="blue darken-4 text-white"
									class="ml-2"
									depressed
									tile
									><v-icon small left>mdi-check-all</v-icon>Activate</v-btn
								>
							</template>
						</template>
						<template v-if="getPermission('property:create')">
							<v-btn
								v-if="customerTab == 'address-book'"
								v-on:click="doAction('new-address')"
								color="blue darken-4 text-white"
								class="ml-2"
								depressed
								tile
								><v-icon small left>mdi-playlist-plus</v-icon>Add New Address</v-btn
							>
						</template>
					</div>
				</v-flex>
			</v-layout>
			<div>
				<div class="mx-4">
					<div class="overflow-y" style="max-height: calc(100vh - 250px)">
						<v-layout class="p-4 border-bottom-light-grey min-height-57px">
							<v-flex class="font-level-3-bold my-auto">
								<span class="detail-svg-icon mr-2">
									<!--begin::Svg Icon-->
									<inline-svg :src="$assetURL('media/custom-svg/asset-color.svg')" />
									<!--end::Svg Icon-->
								</span>
								Property Details
							</v-flex>
						</v-layout>
						<table width="100%" class="detail-table scattered-table">
							<tr>
								<th width="250px">Property #</th>
								<td>
									<ShowValue :object="location" object-key="barcode" label="customer #"></ShowValue>
								</td>
								<th width="250px">Postal Code</th>
								<td>
									<ShowValue
										:object="location"
										object-key="address_postal_code"
										label="Postal Code"
									></ShowValue>
								</td>
							</tr>
							<tr>
								<th width="250px">Customer #</th>
								<td>
									<ShowValue :object="customer" object-key="barcode" label="company name"></ShowValue>
								</td>
								<th width="250px">Customer Name</th>
								<td>
									<ShowValue :object="customer" object-key="display_name" label="display name"></ShowValue>
								</td>
							</tr>
							<tr>
								<th width="250px">Contact Person #</th>
								<td>
									<ShowValue :object="contact_person" object-key="barcode" label="company name"></ShowValue>
								</td>
								<th width="250px">Contact Person Name</th>
								<td>
									<ShowValue
										:object="contact_person"
										object-key="display_name"
										label="display name"
									></ShowValue>
								</td>
							</tr>
							<tr>
								<th width="250px">Address Line 1</th>
								<td>
									<ShowValue
										:object="location"
										object-key="address_line_1"
										label="Address Line 1"
									></ShowValue>
								</td>
								<th width="250px">Address Line 2</th>
								<td>
									<ShowValue
										:object="location"
										object-key="address_line_1"
										label="Address Line 1"
									></ShowValue>
								</td>
							</tr>
							<tr v-if="false">
								<th width="250px">Country</th>
								<td>
									<ShowValue :object="location" object-key="address_country" label="website"></ShowValue>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<DeleteTemplate
				type="Property"
				:delete-text="deleteText"
				v-on:success="goBack()"
				v-on:close="deleteDialog = false"
				:delete-dialog="deleteDialog"
				:delete-url="deleteURL"
				:delete-note="
					customer.activated
						? 'To preserve associated records, you could de-activate the Property instead.'
						: null
				"
			>
				<template v-if="customer.activated" v-slot:extra-btn>
					<v-btn
						class="white--text"
						depressed
						color="blue darken-4"
						tile
						v-on:click="
							deleteDialog = false;
							deactivateDialog = true;
						"
					>
						De-activate
					</v-btn>
				</template>
			</DeleteTemplate>
			<DeactivateTemplate
				type="Property"
				:deactivate-text="deactivateText"
				v-on:success="goBack()"
				v-on:close="deactivateDialog = false"
				:deactivate-dialog="deactivateDialog"
				:deactivate-url="deactivateURL"
			>
			</DeactivateTemplate>
			<ActivateTemplate
				type="Property"
				:activate-text="activateText"
				v-on:success="goBack()"
				v-on:close="activateDialog = false"
				:activate-dialog="activateDialog"
				:activate-url="activateURL"
			>
			</ActivateTemplate>
		</template>
		<template v-else>
			<div class="mx-20 my-40 text-center">
				<v-progress-linear color="orange darken-2" indeterminate height="6"></v-progress-linear>
			</div>
		</template>
	</v-sheet>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GetProperty } from "@/core/lib/contact.lib";
import ShowValue from "@/view/components/ShowValue";
import DeleteTemplate from "@/view/components/DeleteTemplate";
import ActivateTemplate from "@/view/components/ActivateTemplate";
import DeactivateTemplate from "@/view/components/DeactivateTemplate";

export default {
	name: "customer-detail",
	title: "Detail Customer",
	data() {
		return {
			uuid: null,
			barcode: null,
			activateText: null,
			activateURL: null,
			deactivateText: null,
			deactivateURL: null,
			deleteText: null,
			contact_person: [],
			deleteURL: null,
			formValid: true,
			personModel: {},
			deleteDialog: false,
			addressDialog: false,
			deactivateDialog: false,
			activateDialog: false,
			contentLoaded: false,
			pageLoading: false,
			customerTab: null,
			customer: {},
		};
	},
	methods: {
		doAction(param) {
			switch (param) {
				case "edit":
					this.$router.push({
						name: "property-update",
						params: { uuid: this.uuid },
						query: { t: new Date().getTime() },
					});
					break;
				case "delete":
					this.deleteDialog = true;
					break;
				case "deactivate":
					this.deactivateDialog = true;
					break;
				case "activate":
					this.activateDialog = true;
					break;
				case "new-address":
					this.addressDialog = true;
					break;
				case "print-label":
					break;
			}
		},
		getProperty() {
			GetProperty(this.uuid)
				.then((data) => {
					const customer = data.contact;
					this.location = data;
					this.barcode = data.barcode;
					this.customer = customer;
					this.contact_person = data.contact_person;
					this.deleteText = `#${data.barcode}`;
					this.deleteURL = `location/${this.uuid}`;
					this.activateText = `#${data.barcode}`;
					this.activateURL = `location/${this.uuid}/activate`;
					this.deactivateText = `#${data.barcode}`;
					this.deactivateURL = `location/${this.uuid}/de-activate`;
					this.$store.dispatch(SET_BREADCRUMB, [
						{ text: "Property", disabled: true },
						{ text: "Detail", disabled: true },
						{ text: this.barcode, disabled: true },
					]);
				})
				.catch((error) => {
					this.goBack();
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
					this.contentLoaded = true;
				});
		},
	},
	components: {
		ShowValue,
		DeleteTemplate,
		ActivateTemplate,
		DeactivateTemplate,
	},
	mounted() {
		this.$store.dispatch(SET_BREADCRUMB, [
			{ text: "Property", disabled: true },
			{ text: "Detail", disabled: true },
		]);

		const { uuid } = this.$route.params;
		this.uuid = uuid;
		if (!this.uuid) {
			this.goBack();
		}
		this.getProperty();
	},
	beforeDestroy() {
		this.$store.dispatch(SET_BREADCRUMB, []);
	},
};
</script>
